import React, { useEffect, useState } from 'react';
import formConfig from './formConfig';
import Form from '../../common/masterform/Form';
import {useDispatch, useSelector} from 'react-redux';
import { StoreState } from '../../../types/storeTypes';
import { getForm } from '../../common/masterform/formSelectors';
import {info} from 'react-notification-system-redux';
import {RequestId} from '../../utils/requests';
import {getRequestData} from '../../common/commonSelectors';
import {useTranslation} from 'react-i18next';
import GraphModal from '../../forecast-details/graph/GraphModal'
import { setFormValues } from '../../common/masterform/formActions';
import { clearSelectedItem } from '../../forecast-details/actions';

export default function ForecastOverview(props: any) {
    const forecastDetailsFormInfo = useSelector((state: StoreState) => getForm(state,'forecast-details'));
    const requestData = useSelector((state: StoreState) => getRequestData(state, RequestId.FIND_FORECAST_GROUPS));

    const [show, setShow] = useState(false);
    const [fetchOnMount, setFetchOnMount] = useState(false);
    const [initialValues, setInitialValues] = useState();

    const handleClose = () => {
        dispatch(setFormValues("forecast-details", undefined))
        dispatch(clearSelectedItem())
        setShow(false)
    };

    const handleShow = () => setShow(true);

    const dispatch = useDispatch();
    const {t} = useTranslation();

    useEffect(() => {
        if(forecastDetailsFormInfo?.get('values')){
            if(initialValues != forecastDetailsFormInfo.get('values').initialValues){
                setFetchOnMount(forecastDetailsFormInfo?.get('values').fetchOnMount)
                setInitialValues(forecastDetailsFormInfo?.get('values').initialValues)
                handleShow()
            }    
        }
        
        if (requestData && requestData.get('data')) {
            let data = requestData.get('data')
            if (data.get('status') === 'IN_PROCESS') {
                dispatch(info({
                    message: t(data.get('message'))
                }));
            }
        }
    }, [forecastDetailsFormInfo, requestData])

    return (
        <>
            <Form formId="forecast-overview" config={formConfig}/>

            <GraphModal show={show} 
                handleClose={handleClose} 
                fetchOnMount={fetchOnMount} 
                initialValues={initialValues} 
            />
        </>
    )
}
